export const PlebbitTextLogo = (props) => {
  const { color } = props;
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 63.927468 23.281322"
      version="1.1"
    >
      <circle cx="54.459999" cy="3.4413228" r="2.1199999" fill="#a4a4a4" />
      <g fill={color || '#000000'}>
        <path d="M 61.830002,16.521323 V 7.6813228 h 1 a 1,1 0 0 0 1.09,-1 v -0.03 a 1,1 0 0 0 -0.93,-1.12 h -1.16 v -1.65 a 1.23,1.23 0 0 0 -1.12,-1.23 1.2,1.2 0 0 0 -1.27,1.11 v 1.79 h -1 a 1,1 0 0 0 -1.09,1 v 0.07 a 1,1 0 0 0 0.93,1.12 h 1.13 v 8.8100002 a 1.19,1.19 0 0 0 1.19,1.19 v 0 a 1.19,1.19 0 0 0 1.25,-1.12 0.17,0.17 0 0 0 -0.02,-0.1 z" />
        <path d="m 55.640002,7.8113228 a 1.19,1.19 0 1 0 -2.38,0 v 0 8.7100002 a 1.19,1.19 0 0 0 2.38,0 z" />
        <path d="m 27.990098,1.1913224 a 1.19,1.19 0 0 1 1.19,-1.18999994 v 0 a 1.19,1.19 0 0 1 1.19,1.18999994 v 5.32 a 4.11,4.11 0 0 1 3,-1.21 c 3.1,0 5.69,2.85 5.69,6.3500006 0,3.5 -2.51,6.35 -5.65,6.35 a 4.26,4.26 0 0 1 -3.1,-1.23 1.17,1.17 0 0 1 -1.47,0.8 1.2,1.2 0 0 1 -0.85,-1.05 z m 5.43,14.4500006 c 1.83,0 3.32,-1.77 3.32,-4 0,-2.2300006 -1.48,-4.0000006 -3.32,-4.0000006 -1.84,0 -3.31,1.78 -3.31,4.0000006 0,2.22 1.47,3.95 3.3,3.95 z" />
        <path d="m 40.480098,1.1913224 a 1.19,1.19 0 0 1 1.19,-1.18999994 v 0 a 1.18,1.18 0 0 1 1.18,1.18999994 v 0 5.32 a 4.15,4.15 0 0 1 3,-1.21 c 3.1,0 5.69,2.85 5.69,6.3500006 0,3.5 -2.5,6.35 -5.64,6.35 a 4.26,4.26 0 0 1 -3.14,-1.23 1.17,1.17 0 0 1 -1.47,0.8 1.19,1.19 0 0 1 -0.85,-1.05 z m 5.43,14.4500006 c 1.83,0 3.31,-1.77 3.31,-4 0,-2.2300006 -1.47,-4.0000006 -3.31,-4.0000006 -1.84,0 -3.31,1.78 -3.31,4.0000006 0,2.22 1.47,3.95 3.3,3.95 z" />
        <path d="m 25.490098,12.441323 a 1.49,1.49 0 0 0 1.59,-1.38 v -0.15 a 4.81,4.81 0 0 0 -0.1,-0.85 5.83,5.83 0 0 0 -5.51,-4.7600006 c -3.1,0 -5.69,2.85 -5.69,6.3500006 0,3.5 2.55,6.35 5.69,6.35 a 5.66,5.66 0 0 0 4.39,-1.84 1.23,1.23 0 0 0 -0.08,-1.74 l -0.11,-0.09 a 1.29,1.29 0 0 0 -1.58,0.17 3.91,3.91 0 0 1 -2.62,1.12 3.54,3.54 0 0 1 -3.25,-3.18 z m -4,-4.7600006 a 3.41,3.41 0 0 1 3.09,2.6400006 h -6.22 a 3.41,3.41 0 0 1 3.1,-2.6400006 z" />
        <path d="m 0,22.091323 a 1.19,1.19 0 0 0 1.19,1.19 v 0 a 1.19,1.19 0 0 0 1.19,-1.19 v -5.32 a 4.11,4.11 0 0 0 3,1.21 c 3.1,0 5.69,-2.85 5.69,-6.35 0,-3.5000002 -2.51,-6.3500002 -5.65,-6.3500002 a 4.26,4.26 0 0 0 -3.1,1.23 1.17,1.17 0 0 0 -1.47,-0.8 1.2,1.2 0 0 0 -0.85,1.05 z M 5.43,7.6413228 c 1.83,0 3.32,1.77 3.32,4.0000002 0,2.23 -1.48,4 -3.32,4 -1.84,0 -3.31,-1.78 -3.31,-4 0,-2.2200002 1.47,-3.9500002 3.3,-3.9500002 z" />
        <path d="M 13.369813,0.14732282 A 1.19,1.19 0 0 0 12.237,1.3367758 v 6.548828 2.1601572 6.550781 a 1.19,1.19 0 0 0 2.378907,0 V 10.045761 7.8856038 1.3367758 A 1.19,1.19 0 0 0 13.369813,0.14732282 Z" />
      </g>
    </svg>
  );
};

export const PlebLogo = () => {
  return (
    <svg version="1.1" viewBox="0 0 306.14 306.14" xmlns="http://www.w3.org/2000/svg">
      <circle cx="153.07" cy="153.07" r="153.07" fill="#fff" />
      <g transform="translate(-229.37 -308.69)">
        <circle cx="334.04" cy="399.32" r="14.563" fill="#a4a4a4" />
        <circle cx="476.01" cy="400.8" r="14.563" fill="#a4a4a4" />
        <path
          d="m427.18 415.83 26.214 97.087-80.583-1.9418"
          fill="none"
          stroke="#a4a4a4"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="13.5"
        />
        <path
          d="m359.22 557.57 100.97 3.8835"
          fill="none"
          stroke="#a4a4a4"
          strokeLinecap="round"
          strokeWidth="13.5"
        />
      </g>
    </svg>
  );
};
